import { Button, ButtonGroup, Popover } from '@material-ui/core';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import React, { Component } from 'react';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';


class InjectedFilter extends Component {
    constructor(props) {
        super(props);
        if(props.selected)
            this.state = { isCalendarOpen:false};
        else
            this.state = { isCalendarOpen:false};
    }

    selectionChanged(e) {
        this.closeDatePicker()
        const date = e.toISOString().split("T")[0]
        if(this.props.onChange)
            this.props.onChange(date);
    }
    openDatePicker(e) {
        this.setState({filterAnchor:e.currentTarget, isCalendarOpen:true});
    }
    closeDatePicker() {
        this.setState({filterAnchor:null, isCalendarOpen:false});
    }

    render() {

        return (
            <div style={{float:'left', marginLeft:"25px", marginBottom:"5px"}}>{this.props.showTitle?<b>{this.props.name}</b>:""}
                <ButtonGroup style={{marginTop:'7px', marginLeft: '5px'}} variant="contained" color="secondary" aria-label="split button">
                    <Button color="secondary" onClick={this.openDatePicker.bind(this)}>{this.props.selected ? this.props.selected : "Select Pilot Start Date"}</Button>
                    <Button color="secondary" size="small" aria-haspopup="true" onClick={this.openDatePicker.bind(this)}>
                        <CalendarIcon />
                    </Button>
                </ButtonGroup>


                <Popover id="datepickerMenu" open={Boolean(this.state.filterAnchor)} anchorEl={this.state.filterAnchor} onClose={this.closeDatePicker.bind(this)}> 
                    <MuiPickersUtilsProvider utils={DateFnsUtils} anchorEl={this.state.filterAnchor}>
                        <KeyboardDatePicker 
                            id="date-picker-dialog" 
                            orientation="landscape" 
                            variant="static" 
                            autoOk 
                            value={this.props.selected} 
                            onChange={this.selectionChanged.bind(this)} 
                            open={this.state.isCalendarOpen}
                            onClose={this.closeDatePicker.bind(this)}
                        />
                    </MuiPickersUtilsProvider>
                </Popover>
            </div>
        );

    }
} // end of class

export default InjectedFilter;
